import { render } from "./StudentCourseMaterialsView.vue?vue&type=template&id=6fa3bb45"
import script from "./StudentCourseMaterialsView.vue?vue&type=script&lang=js"
export * from "./StudentCourseMaterialsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__